import { render, staticRenderFns } from "./CustomRadio.vue?vue&type=template&id=8c10501e&scoped=true"
import script from "./CustomRadio.vue?vue&type=script&lang=js"
export * from "./CustomRadio.vue?vue&type=script&lang=js"
import style0 from "./CustomRadio.vue?vue&type=style&index=0&id=8c10501e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c10501e",
  null
  
)

export default component.exports